/* eslint-disable */
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CombinedState as DashboardCombinedState } from '../../reducers/dashboard/reducers-dashboard';
import { getLocaleId } from '@angular/common';

export function formatNumber(num: number, symbol: string, hideHundreds?: boolean): string {
  hideHundreds = hideHundreds || !symbol || ['PNRs', 'UAH', 'JPY'].indexOf(symbol) > -1;
  let intPart = (hideHundreds ? Math.round(num) : Math.ceil(num)).toString();
  const decimalPart = hideHundreds
    ? ''
    : '.' +
      num
        .toFixed(2)
        .toString()
        .split('.')[1];
  if (intPart.length > 4) {
    intPart = intPart.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
  }
  return intPart + decimalPart;
}

export function formatPercentage(percentage: number): string {
  return percentage > 0.1 ? percentage.toFixed(2) : '~0.1';
}

export function formatDetailsValue(field: { key: string; value: number }, symbol: string): string {
  return 'nights' === field.key ? field.value.toString() : formatNumber(field.value, symbol) + ' ' + symbol;
}

export function ngbDateToString(date: NgbDateStruct): string {
  return date && date.year + '-' + date.month.toString().padStart(2, '0') + '-' + date.day.toString().padStart(2, '0');
}

export function stringToNgbDate(date: string): NgbDate {
  if (null === date) {
    return null;
  }
  const parts = date.split('-').map(v => parseInt(v, 10));
  return NgbDate.from({
    year: parts[0],
    month: parts[1],
    day: parts[2]
  });
}

export function getFilterBySymbol(dashboard: DashboardCombinedState) {
  const [filterBy, currency, turnover] = [
    dashboard.options.filterBy,
    dashboard.config.config.currency,
    dashboard.options.filters.turnover
  ];

  switch (filterBy) {
    case 'PNR':
      return 'TOMA' === turnover ? '' : 'PNRs';
    case 'value':
      return currency;
    default:
      return '';
  }
}

export function getFilterBySymbolForDetails(dashboard: DashboardCombinedState) {
  const [filterBy, currency /* turnover */] = [
    dashboard.options.filterBy,
    dashboard.config.config.currency,
    dashboard.options.filters.turnover
  ];

  switch (filterBy) {
    case 'PNR':
      return currency;
    case 'value':
      return currency;
    default:
      return '';
  }
}

export function camelize(value: string): string {
  const parts = value.split(/[_\s]+/);

  return parts.map(word => word[0].toUpperCase() + word.substr(1)).join('');
}

export function getLocale() {
  return sessionStorage.getItem('preferredLocale') || 'en';
}

export const getCurrencyLocale = (() => {
  let locale: string;
  return function() {
    if (!locale) {
      try {
        getLocaleId('direct');
        locale = 'direct';
      } catch (_) {
        locale = getLocale();
      }
    }

    return locale;
  };
})();
